import { TiendaPerfectaVisitHistoryParams } from 'models/TiendaPerfecta';

/**
 * Identity of a query: range, zones and distributors. Empty while the query is
 * not ready. Anything keyed on it (the fetch, the map's route visibility)
 * resets exactly when the filters change.
 */
export const visitHistoryQueryKey = (
  params: TiendaPerfectaVisitHistoryParams | undefined
): string =>
  params
    ? [
        params.from,
        params.to,
        (params.zoneIds ?? []).join(','),
        (params.distributorIds ?? []).join(','),
      ].join('|')
    : '';
